import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../components/Header/Header";
import Tabs from "../../../components/Tabs/Tabs";
import mes_tab_data from "../../../assets/mockedData/mes_tab_data";
import { savePathToLocalStorage } from "../../../utils/helpers";
import mesApi from "../../../Api/mes.api";
import { Trial } from "../../../types/mes";
import { ToastContainer, toast } from "react-toastify";
import { formatTrialDate, getTrialId, getTrialName } from "./trialUtils";

/**
 * Lista pokusa — kreiranje na /mes/trials/new, detalj na /mes/trials/:id
 */
const Trials = () => {
  savePathToLocalStorage();

  const [trials, setTrials] = useState<Trial[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const trialsData = await mesApi.getTrials({});
      setTrials(trialsData);
    } catch (err: any) {
      toast.error("Greska pri ucitavanju: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFinalizeTrial = async (trialId: number, finalScore: number) => {
    try {
      await mesApi.finalizeTrial(trialId, finalScore);
      toast.success("Pokus finaliziran");
      loadData();
    } catch (err: any) {
      toast.error("Greska: " + err.message);
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case "draft": return "Nacrt";
      case "confirmed": return "Potvrdjeno";
      case "in_progress": return "U tijeku";
      case "completed": return "Zavrseno";
      case "promoted": return "Promovirano";
      case "archived": return "Arhivirano";
      default: return status;
    }
  };

  return (
    <div className="mes-page trials-page">
      <Header title="MES - Pokusi" />
      <div className="main-content-flex">
        <Tabs data={mes_tab_data} />
        <div className="section mes-content">
          <div className="mes-section">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "0.5rem" }}>
              <h3 style={{ margin: 0, border: "none", padding: 0 }}>Pokusi</h3>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <Link to="/mes/saved-trials" className="btn-secondary">
                  Spremljene probe
                </Link>
                <Link to="/mes/trials/new" className="btn-primary">
                  + Nova proba
                </Link>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="mes-section loading-state">Ucitavanje...</div>
          ) : trials.length === 0 ? (
            <div className="mes-section empty-state">
              <p>Nema pokusa.</p>
              <Link to="/mes/trials/new" className="btn-primary">
                Kreiraj prvu probu
              </Link>
            </div>
          ) : (
            <div className="mes-section trials-section">
              <div className="trial-cards">
                {trials.map((trial) => (
                  <div key={getTrialId(trial)} className="trial-card">
                    <div className="trial-header">
                      <div className="trial-name">{getTrialName(trial)}</div>
                      <div className="trial-date">{formatTrialDate(trial.TrialDate)}</div>
                    </div>
                    <div className="trial-product">
                      {trial.Product_ProductToTrial?.ProductName || "N/A"}
                    </div>
                    <div className="trial-info-row">
                      <div className="trial-score">
                        {(trial as any).final_score != null ? (
                          <>
                            <span className="score-value">{(trial as any).final_score}</span>
                            <span className="score-label">/ 10</span>
                          </>
                        ) : (
                          <span className="score-label">Nije ocijenjeno</span>
                        )}
                      </div>
                      <span className={`status-pill status-${trial.Status}`}>
                        <span className="status-dot"></span>
                        {getStatusLabel(trial.Status)}
                      </span>
                    </div>
                    <div className="trial-actions">
                      <Link to={`/mes/trials/${getTrialId(trial)}`} className="btn-sm btn-secondary">
                        Otvori
                      </Link>
                      {(trial.Status === "confirmed" || trial.Status === "draft") && (
                        <button
                          type="button"
                          className="btn-sm btn-success"
                          onClick={() => {
                            const score = prompt("Unesite konacnu ocjenu (1-10):");
                            if (score) {
                              const numScore = parseFloat(score);
                              if (numScore >= 1 && numScore <= 10) {
                                handleFinalizeTrial(getTrialId(trial), numScore);
                              } else {
                                toast.error("Ocjena mora biti izmedju 1 i 10");
                              }
                            }
                          }}
                        >
                          Finaliziraj
                        </button>
                      )}
                    </div>
                    {trial.Notes && <div className="trial-notes">{trial.Notes}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <ToastContainer autoClose={5000} position="bottom-right" hideProgressBar={false} theme="colored" />
    </div>
  );
};

export default Trials;
